import React from 'react';
import { Sparkles } from 'lucide-react';
import { TIER_THEME, getTier } from '@/constants/tiers';

/**
 * Inline status pill. Use anywhere a user's tier should be visually identified
 * (e.g. headers, profile rows, account dropdown). Compact by default; pass
 * `size="lg"` for hero placements.
 */
export default function StatusBadge({ tier = 'member', size = 'sm', showSparkle = false, className = '' }) {
  const t = getTier(tier);
  const theme = TIER_THEME[tier] || TIER_THEME.member;

  const sizeClasses = size === 'lg'
    ? 'px-4 py-1.5 text-sm tracking-wider'
    : 'px-2.5 py-1 text-[11px] tracking-widest';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium uppercase ${theme.chip} ${sizeClasses} ${className}`}
    >
      {showSparkle && tier !== 'member' && <Sparkles className="w-3 h-3" strokeWidth={2} />}
      {t.name}
    </span>
  );
}
